const A = "https://customer-assets-jai6qajn.emergentagent.net/job_eleganza-notturna/artifacts/";

export const IMAGES = {
  logo: A + "32l2fp55_WhatsApp%20Image%202026-09-26%20at%2022.06.43.jpeg",
  hero_club: A + "qag882z4_bar.webp",
  hero_spa: A + "jfruyhyx_piscina%20idromassaggio.webp",
  club_bar: A + "qag882z4_bar.webp",
  club_red: A + "qag882z4_bar.webp",
  club_sil: A + "uqnsokrk_ingresso%20spa.webp",
  club_duo: A + "qag882z4_bar.webp",
  spa_candles: A + "p5fimecc_sauna.webp",
  spa_aroma: A + "7x0p7he7_sauna%202.webp",
  spa_amb: A + "jfruyhyx_piscina%20idromassaggio.webp",
  spa_entrance: A + "uqnsokrk_ingresso%20spa.webp",
};
